import React, { useEffect, useState } from 'react';
import {
  SiSpringboot, SiAngular, SiJenkins, SiDocker, SiAmazonaws, SiMysql
} from 'react-icons/si';
import { SiRedis } from 'react-icons/si';
import { FaAws } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import TechCard from '../../../../Components/TechCard';

// Realtime Advertising Platform specific tech stack
const categories = ['Backend', 'Frontend', 'Cloud & DevOps', 'Database'];

const techStacks = {
  'Backend': [
    { name: 'Spring Boot', icon: <SiSpringboot className="text-green-500" /> },
  ],
  'Frontend': [
    { name: 'Angular', icon: <SiAngular className="text-red-500" /> },
  ],
  'Cloud & DevOps': [
    { name: 'AWS', icon: <FaAws className="text-orange-400" /> },
    { name: 'Jenkins', icon: <SiJenkins className="text-red-500" /> },
    { name: 'Docker', icon: <SiDocker className="text-blue-400" /> },
  ],
  'Database': [
    { name: 'MySQL', icon: <SiMysql className="text-blue-400" /> },
    { name: 'Redis', icon: <SiRedis className="text-red-600" /> },
  ],
};

const RealtimeAdvertisingTechSolutions = () => {

   const [activeCategory, setActiveCategory] = useState('Backend');

  useEffect(() => {
    AOS.init({ once: false });
  }, []);

  useEffect(() => {
    AOS.refresh(); // Refresh AOS when activeCategory changes
  }, [activeCategory]);

    return (
      <section className="bg-bgDefault text-white px-4 py-12 lg:py-16 lg:px-36 ">
        <div className="container xl:mx-auto xl:max-w-screen-xl ">
          <div className="lg:text-center text-left mb-10">
            <h2 className="font-dmsans font-bold text-[35px] leading-[43px] tracking-[-6%] lg:text-[60px] lg:leading-[100%]">
             Tech Stack Used
            </h2>
          </div>

          {/* Tabs */}
          <div className="flex flex-nowrap sm:flex-wrap overflow-x-auto sm:overflow-visible justify-start sm:justify-center lg:gap-4 gap-2 mb-10">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
               className={`whitespace-nowrap px-4 py-2 text-body-sm transition-all duration-200 font-medium text-center transform
                hover:scale-105 active:scale-95 active:shadow-inner
                ${
                  activeCategory === category
                    ? 'border border-[#00E599] text-[#FFFFFF] bg-[#121212] lg:text-lg font-dmsans font-medium leading-snug text-body'
                    : 'lg:text-lg text-[#9E9E9E] font-dmsans font-medium leading-snug text-body hover:text-[#FFFFFF]'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Tech Stack Grid */}
          <div
            className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5
              justify-items-center lg:gap-y-4 lg:gap-x-4 lg:px-24 xl:px-24 gap-y-4 gap-x-4
              max-h-[400px] overflow-y-auto sm:overflow-visible"
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1000"
             key={activeCategory}
          >
           {(techStacks[activeCategory] || []).map((tech, index) => (
              <TechCard key={index} icon={tech.icon} name={tech.name} />
            ))}
          </div>
        </div>
      </section>
    );
  };

export default RealtimeAdvertisingTechSolutions;
